import { Component, effect, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserPreferences } from '@iot-platform/models/common';
import { NotificationModule } from '@iot-platform/notification';
import { PreferencesFacade, UserProfileService } from '@iot-platform/data-access/users';

@Component({
  imports: [RouterModule, NotificationModule],
  selector: 'xmqtt-root',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="default-theme">
      <router-outlet />
      <iot-platform-notification />
    </div>
  `
})
export class AppComponent {
  protected readonly preferencesFacade: PreferencesFacade = inject(PreferencesFacade);
  protected readonly userProfileService: UserProfileService = inject(UserProfileService);
  private preferences: Signal<UserPreferences> = this.preferencesFacade.preferences;

  constructor() {
    effect(() => {
      const preferences = this.preferences();
      if (preferences) {
        this.userProfileService.setThemeOverlay();
        this.preferencesFacade.setLanguage(preferences.appLanguage);
      }
    });
  }
}
